import { request } from './http';
import type { PaginatedResult } from '@/types/api';
import type { WalletLedgerListQuery, WalletLedgerRecord } from '@/types/walletLedger';

export const adminWalletLedgerApi = {
  list(query: WalletLedgerListQuery) {
    return request<PaginatedResult<WalletLedgerRecord>>({
      url: '/admin/wallet-ledger',
      method: 'GET',
      params: query,
    });
  },
};
